import { useQuery } from "react-query";
import { mobileAppSettingsApi } from "@/react/api/mobileAppSettingsApi";
import type { DataResponse } from "./useMobileAppSettings";
import { SHOW_QUERY_KEY } from "./useMobileAppSettings";

export const useLazyMobileAppSettings = () => {
  const { isLoading, data, refetch } = useQuery<DataResponse>(
    SHOW_QUERY_KEY,
    mobileAppSettingsApi.show,
    {
      enabled: false,
    },
  );

  const { mobile_home_segments: mobileHomeSegments, ...rest } =
    data?.community_setting || {
      mobile_home_segments: [],
    };
  const defaultValues = { community_setting: rest };

  return {
    defaultValues,
    mobileHomeSegments,
    isLoading,
    fetchSettings: refetch,
  };
};
